import { useEffect, useState } from 'react'
import { ListFilterDrawer } from '@/components/ui/ListFilterDrawer'
import { SearchableSelect } from '@/components/ui/SearchableSelect'
import { formatDateForAPI } from '@/features/invitee/utils/inviteeFormatters'
import { buildYearOptions } from '../utils/reportRolling52Weeks'
import { ReportDateRangePicker } from './ReportDateRangePicker'
import type { WeeklyReimbursementsFilterState } from '../types/filters'
import type { WeeklyReimbursementsFiltersProps } from '../types/components'
import { WEEK_FILTER_OPTIONS } from '../constants/filterOptions'
import { LABEL_CLASS } from '../constants/configuredReportStyles'


export function WeeklyReimbursementsFilters({
  filters,
  isOpen,
  onClose,
  onApply,
  onReset,
  onYearChange,
}: WeeklyReimbursementsFiltersProps) {
  const [draft, setDraft] = useState<WeeklyReimbursementsFilterState>(filters)
  const yearOptions = buildYearOptions(5)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: re-sync the filter draft to applied filters each time the drawer opens
    if (isOpen) setDraft(filters)
  }, [isOpen, filters])

  return (
    <ListFilterDrawer
      isOpen={isOpen}
      onClose={onClose}
      onReset={onReset}
      onDone={() => {
        onApply(draft)
        onClose()
      }}
      testIdPrefix="weekly-reimbursements"
    >
      <div className="space-y-4">
        <div className="space-y-2">
          <label className={LABEL_CLASS}>Select year</label>
          <SearchableSelect
            searchable={false}
            options={yearOptions.map((y) => ({
              value: String(y),
              label: String(y),
            }))}
            value={String(draft.year)}
            onChange={(val) => {
              const nextYear = Array.isArray(val) ? val[0] : val
              if (!nextYear) return
              const next = onYearChange(nextYear)
              setDraft(next)
            }}
            placeholder="Select year"
          />
        </div>

        <div className="space-y-2">
          <label className={LABEL_CLASS}>Contract start dates</label>
          <ReportDateRangePicker
            startDate={draft.fromDt}
            endDate={draft.toDt}
            onChange={(start, end) =>
              setDraft({
                ...draft,
                fromDt: start ? formatDateForAPI(start) : '',
                toDt: end ? formatDateForAPI(end) : '',
              })
            }
          />
        </div>

        <div className="space-y-2">
          <label className={LABEL_CLASS}>Week type</label>
          <SearchableSelect
            options={WEEK_FILTER_OPTIONS}
            value={draft.week_filter}
            onChange={(val) =>
              setDraft({ ...draft, week_filter: Array.isArray(val) ? val : [] })
            }
            placeholder="All"
            multiple
          />
        </div>
      </div>
    </ListFilterDrawer>
  )
}

export type { WeeklyReimbursementsFilterState } from '../types/filters'

